// https://awik.io/determine-color-bright-dark-using-javascript/
// Returns a number between 0 and ~255, where 0 is dark, and 255 is brightest
export const getPerceivedBrightness = (color: string): number => {
    const hex = color.length === 4 ? color.replace(/(\w)/g, '$10') : color;
    const parsed = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})[a-f\d]*$/i.exec(hex);

    const r = parseInt(parsed ? parsed[1] : '0', 16);
    const g = parseInt(parsed ? parsed[2] : '0', 16);
    const b = parseInt(parsed ? parsed[3] : '0', 16);

    // https://alienryderflex.com/hsp.html
    return Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
};
